/**
 * Locale service for pleased app.
 */
export * from '@/locales/languages';
export * from './i18n';
